/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import useMessageDispatcher from 'hooks/useMessageDispatcher';
import axios from 'axios';
import Add from './Add';
import List from './List';

const headers = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
        'Content-Type': 'application/json'
    }
};
const initialValues = {
    id: '',
    sessionIds: [],
    courseDetailIds: [],
    semList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    examName: '',
    startDate: '',
    endDate: '',
    semesterNo: '',
    semesterExam: true,
    examList: [],
    sessionList: [],
    examMode: '',
    courseDetailList: []
};
const validationSchema = Yup.object().shape({
    examName: Yup.string().required('Exam Name is required'),
    // startDate: Yup.date().required('Start Date is required'),
    // endDate: Yup.date().required('End Date is required').min(Yup.ref('startDate'), 'End Date cannot be before Start Date'),
    sessionIds: Yup.array().min(1, 'Batch must be selected').required('Batch is required'),
    courseDetailIds: Yup.array().min(1, 'At least one program must be selected').required('program is required')
});

const PreviousExamSetup = () => {
    const instituteId = localStorage.getItem('instituteId');
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const showMessage = useMessageDispatcher();
    const formikRef = useRef();
    const fetchSessions = async () => {
        try {
            const response = await axios.get(`/v1/session/list?instituteId=${instituteId}`, headers);
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    formikRef?.current?.setFieldValue('sessionList', response?.data?.SessionList);
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchCourseDetails = async (sessionId) => {
        try {
            const response = await axios.get(
                `/v1/course-details/list/by-college-institute?instituteId=${instituteId}&sessionId=${sessionId}`,
                headers
            );
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    formikRef?.current?.setFieldValue('courseDetailList', response?.data?.courseDetailList);
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const handleACreateExam = async (values, { resetForm }) => {
        const payload = {
            id: values?.id,
            sessionIds: values?.sessionIds,
            courseDetailIds: values?.courseDetailIds,
            examName: values?.examName,
            semesterNo: values?.semesterNo,
            startDate: values?.startDate,
            endDate: values?.endDate,
            semesterExam: true,
            formAcceptanceDate: '',
            formSubmissionDate: '',
            grievanceDate: '',
            examMode: values?.examMode
        };
        try {
            const response = await axios.post(`/v1/exams/add-update?previousExam=true`, payload, headers);
            if (response.status === 200) {
                resetForm();
                setOpen(false);
                fetchExams();
                if (response.data.code !== '403') {
                    showMessage({ message: response?.data?.Msg, color: 'success' });
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchExams = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(`/v1/exams/exam-group/list`, headers);
            if (response.status === 200) {
                setIsLoading(false);
                if (response.data.code !== '403') {
                    formikRef?.current?.setFieldValue('examList', response?.data?.data);
                }
            }
        } catch (error) {
            setIsLoading(false);
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    useEffect(() => {
        fetchExams();
    }, []);
    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleACreateExam} innerRef={formikRef}>
            {({ errors, touched, values, setFieldValue, handleChange, resetForm }) => (
                <>
                    <List
                        setOpen={setOpen}
                        isLoading={isLoading}
                        values={values}
                        setFieldValue={setFieldValue}
                        fetchSessions={fetchSessions}
                        fetchCourseDetails={fetchCourseDetails}
                    />
                    {open && (
                        <Add
                            open={open}
                            setOpen={setOpen}
                            values={values}
                            setFieldValue={setFieldValue}
                            touched={touched}
                            errors={errors}
                            handleChange={handleChange}
                            resetForm={resetForm}
                            fetchSessions={fetchSessions}
                            fetchCourseDetails={fetchCourseDetails}
                            fetchExams={fetchExams}
                        />
                    )}
                </>
            )}
        </Formik>
    );
};

export default PreviousExamSetup;
